import axios from 'axios';
import { injectable } from 'inversify';
import { IAPIService } from './interfaces';
@injectable()
export default class APIService implements IAPIService {

  constructor(){
    
  }
  get = (url: string, config?: any): Promise<any> => axios.get(url);
  post = (url: string, data: Object, config?: any): Promise<any> => axios.post(url, data, config);
  put = (url: string, data: Object, config?: any): Promise<any> => axios.put(url, data, config);
  patch = (url: string, data: Object, config?: any): Promise<any> => axios.patch(url, data, config);
  delete = (url: string, config?: any): Promise<any> => axios.delete(url, config);
}